import React, { useEffect, useState } from "react";
import { db } from "../utils/firebase";
import { doc, getDoc, setDoc } from "firebase/firestore";
import { useAuth } from "../context/AuthContext";

const GUEST_KEY = "kd_age_verified";

function AgeVerificationModel() {
  const { user, loading } = useAuth();
  const [showModal, setShowModal] = useState(false);
  const [checking,  setChecking]  = useState(true);

  useEffect(() => {
    if (loading) return;

    const check = async () => {
      if (user) {
        // Logged-in: verify against Firestore — cannot be bypassed via browser storage
        try {
          const snap = await getDoc(doc(db, "users", user.uid));
          setShowModal(!(snap.exists() && snap.data().ageVerified === true));
        } catch {
          // Firestore unavailable — fall back to in-memory flag
          setShowModal(!guestVerifiedInMemory);
        }
      } else {
        // Guest: use sessionStorage — persists for the browser tab session only
        setShowModal(sessionStorage.getItem(GUEST_KEY) !== "true");
      }
      setChecking(false);
    };

    check();
  }, [user, loading]);

  // Lock page scroll while modal is open
  useEffect(() => {
    if (!showModal) return;
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => { document.body.style.overflow = prev; };
  }, [showModal]);

  const handleAccept = async () => {
    if (user) {
      try {
        // Persist to Firestore so it survives page refreshes for logged-in users
        await setDoc(doc(db, "users", user.uid), { ageVerified: true }, { merge: true });
      } catch {
        // Firestore unavailable — fall back to sessionStorage
        sessionStorage.setItem(GUEST_KEY, "true");
      }
    } else {
      // Guest: persist for this browser tab session
      sessionStorage.setItem(GUEST_KEY, "true");
    }
    setShowModal(false);
  };

  const handleReject = () => {
    alert("You must be 21 or older to enter this site.");
    window.location.href = "https://www.google.com";
  };

  if (checking || !showModal) return null;

  return (
    <div className="fixed inset-0 z-50">
      {/* overlay */}
      <div className="absolute inset-0 bg-black/70" />

      {/* centered card */}
      <div className="absolute inset-0 z-[60] flex items-center justify-center p-4">
        <div className="w-full max-w-md rounded-xl bg-card shadow-2xl border border-border p-6">
          <h2 className="text-2xl font-bold text-center text-foreground mb-2">Age Verification</h2>
          <p className="text-sm text-[var(--color-muted-foreground)] text-center mb-6">
            You must be <strong className="text-foreground">21 years or older</strong> to enter this site. Please verify your age.
          </p>

          <div className="flex gap-3">
            <button
              onClick={handleAccept}
              className="flex-1 rounded-md bg-green-600 text-white py-2.5 font-medium hover:bg-green-700 transition"
            >
              I am 21+
            </button>
            <button
              onClick={handleReject}
              className="flex-1 rounded-md bg-muted text-foreground py-2.5 font-medium hover:opacity-80 transition"
            >
              I am under 21
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AgeVerificationModel;
